import { render, staticRenderFns } from "./swiper-win-prize.vue?vue&type=template&id=b2b38c2c&scoped=true&"
import script from "./swiper-win-prize.vue?vue&type=script&lang=js&"
export * from "./swiper-win-prize.vue?vue&type=script&lang=js&"
import style0 from "./swiper-win-prize.vue?vue&type=style&index=0&id=b2b38c2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b38c2c",
  null
  
)

export default component.exports